import { NavItem } from "@/types";
import {
  Archive,
  Database,
  File,
  LayoutDashboard,
  Mail,
  MailCheck,
  MailOpen,
  SendToBack,
  Users,
} from "lucide-react";

export const BASE_URL = process.env.NEXT_PUBLIC_API_URL;
export const REGION_URL = process.env.NEXT_PUBLIC_API_REGION;
export const WEB_URL = process.env.NEXT_PUBLIC_URL;

type navDateType = {
  navItems: NavItem[];
};

export const getNavData = (): navDateType => {
  return {
    navItems: [
      {
        title: "Dashboard",
        url: "/dashboard",
        icon: LayoutDashboard,
      },
      {
        title: "Surat Masuk",
        url: "",
        icon: MailOpen,
        items: [
          { title: "Surat Fisik", url: "/incoming-mail/physical" },
          { title: "Surat Internal", url: "/incoming-mail/internal" },
          { title: "Surat Kunjungan", url: "/incoming-mail/visit" },
          { title: "Surat Audiensi", url: "/incoming-mail/audience" },
        ],
      },
      {
        title: "Disposisi",
        url: "/disposition",
        icon: SendToBack,
      },
      {
        title: "Surat Keluar",
        url: "/outgoing-mail",
        icon: Mail,
      },
      {
        title: "Validasi Surat Keluar",
        url: "",
        icon: MailCheck,
        items: [
          {
            title: "Verifikasi",
            url: "/verification",
          },
          {
            title: "Tanda Tangan",
            url: "/signature",
          },
        ],
      },
      {
        title: "Arsip Surat",
        url: "/archive",
        icon: Archive,
      },
      {
        title: "Manajemen Pengguna",
        url: "",
        icon: Users,
        items: [
          {
            title: "Users",
            url: "/users",
          },
          {
            title: "Roles",
            url: "/roles",
          },
        ],
      },
      {
        title: "Template Surat",
        url: "",
        icon: File,
        items: [
          // {
          //   title: "Kop Surat",
          //   url: "/template/header",
          // },
          {
            title: "Template Surat",
            url: "/template/letter",
          },
        ],
      },
      {
        title: "Data Master",
        url: "",
        icon: Database,
        items: [
          {
            title: "Kategori Surat",
            url: "/data-master/mail/category",
          },
          {
            title: "Sifat Surat",
            url: "/data-master/mail/nature",
          },
          {
            title: "Prioritas",
            url: "/data-master/mail/priority",
          },
          // {
          //   title: "Instansi",
          //   url: "/data-master/institution",
          // },
        ],
      },
    ],
  };
};

export const navMenu = [
  {
    label: "Beranda",
    href: "/#hero",
  },
  {
    label: "Kunjungan",
    href: "/#Kunjungan",
  },
  {
    label: "Aplikasi Pendukung",
    href: "/#Aplikasi-Pendukung",
  },
];
